import { render, staticRenderFns } from "./QASession.vue?vue&type=template&id=71681d91&scoped=true&"
import script from "./QASession.vue?vue&type=script&lang=js&"
export * from "./QASession.vue?vue&type=script&lang=js&"
import style0 from "./QASession.vue?vue&type=style&index=0&id=71681d91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71681d91",
  null
  
)

export default component.exports